import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#292A2E",
      d: "M8 2a7.336 7.336 0 0 1 7.213 6A7.336 7.336 0 0 1 .787 8 7.336 7.336 0 0 1 8 2m0 10.667A6.004 6.004 0 0 0 13.851 8 6.004 6.004 0 0 0 2.15 8 6 6 0 0 0 8 12.667M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0-1.333a1.667 1.667 0 1 0 0-3.334 1.667 1.667 0 0 0 0 3.334"
    }, null, -1)
  ]))]))
}
export default { render: render }